import { useParams } from 'react-router-dom';
import { CircularProgress, Grid, Stack } from '@mui/material';
import { useGetDatasetQuery } from '~/api/v2/hooks';
import { modalContainerHeight, modalOverflowBoxStyles } from '~/components/styles';
import { useWbsWarningAlert } from '~/hooks';
import { WbsCodeField } from '~/pages/ProjectDetailsPage/components';
import {
  DataClassificationField,
  DataLocationField,
  DeidentifiedStatusField,
  DescriptionField,
  MdtIdField,
  NameField,
  OperatingUnitOwnerField,
  ProvenanceField,
  StatusField,
} from '..';

const DatasetDetailsForm = () => {
  const datasetId = +useParams().id!;
  const { data, isFetching } = useGetDatasetQuery({ datasetId }, { skip: !datasetId });
  const wbsAlert = useWbsWarningAlert({ data, entityLabel: 'dataset', isLoading: isFetching });

  const formConfig = [
    { field: <NameField />, size: 6 },
    { field: <MdtIdField />, size: 6 },
    { field: <DataLocationField />, size: 6 },
    { field: <StatusField />, size: 6 },
    { field: <OperatingUnitOwnerField />, size: 6 },
    { field: <DeidentifiedStatusField />, size: 6 },
    { field: <DataClassificationField />, size: 6 },
    { field: <WbsCodeField />, size: 6 },
    { field: <DescriptionField />, size: 12 },
    { field: <ProvenanceField />, size: 12 },
  ];

  return (
    <Stack sx={{ ...modalOverflowBoxStyles, height: `calc(${modalContainerHeight} - 240px)` }} spacing={2}>
      {wbsAlert}
      {isFetching ? (
        <CircularProgress size={70} sx={{ color: '#1010eb', alignSelf: 'center' }} />
      ) : (
        <Grid container spacing={[6, 6, 4]}>
          {formConfig.map(({ field, size }, index) => (
            <Grid key={index} size={size}>
              {field}
            </Grid>
          ))}
        </Grid>
      )}
    </Stack>
  );
};

export default DatasetDetailsForm;
